import calculateTimeDifference from "./calculateTimeDifference.js";
import { humanized } from "./locales/index.js";
const humanize = (date, lang = 'es')=>{
    const langKey = lang;
    return calculateTimeDifference(date, humanized[langKey]);
};
const date_humanize = humanize;
export default date_humanize;
